export const sumObject = (objectToSum?: object) => {
  if (!objectToSum) return 0;

  return Object.values(objectToSum)
    .filter((value) => typeof value !== "string")
    .reduce((total, current) => current + total, 0);
};
